
export enum AdvanceBeyondTypeCd {
	ADV_CARR = 'AdvCarr',
	BYD_CARR = 'BydCarr'}

